<div class="loading-container" *ngIf="showSpinner">
  <div class="loading-gif">
    <img src="../assets/images/Spinner.gif" />
  </div>
  <div class="count-container" *ngIf="sendClientChoice === sendOptions.all">
    Clients Sent: {{ clientsSent }} / {{ clientIdList.length }}
  </div>
</div>


<div class="row">
  <div class="col-md-6">

    <div class="row">
      <div class="col-md-12">
        <div class="mb-3 col-md-12">
          <p class="mb-3 mt-3 section-header">
            Client Billing Period: {{ displayDate | date: "MM/yyyy" }}
          </p>
        </div>
    
        <div class="input-group mb-3 col-md-12">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <input
                type="radio"
                name="whoToSend"
                id="ChkBoxSendAllClients"
                value="0"
                (click)="sendClientChoice = sendOptions.all"
              />
            </div>
          </div>
          <Label class="form-control" for="ChkBoxSendAllClients"
            >Send All Clients</Label
          >
        </div>
    
        <div class="input-group mb-3 col-md-12">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <input
                type="radio"
                name="whoToSend"
                value="1"
                id="clientSelect"
                (click)="sendClientChoice = sendOptions.single"
              />
            </div>
          </div>
          <Label
            class="form-control"
            for="clientSelect"
            *ngIf="sendClientChoice !== sendOptions.single"
          >
            Pick A Client
          </Label>
          <ng-select
            *ngIf="sendClientChoice === 'single'"
            style="flex: 1 1 auto;"
            [virtualScroll]="true"
            [items]="clientsAvailable"
            bindLabel="partyName"
            bindValue="clientParty.mailStop"
            [searchFn]="matchClientPartyRow"
            [(ngModel)]="clientSelected"
            (close)="menuOpen = false"
            (open)="menuOpen = true"
          >
            <ng-template ng-option-tmp let-item="item">
              {{ item.clientParty.mailStop }} -- {{ item.partyName }}
            </ng-template>
          </ng-select>
        </div>
    
        <div class="mt-3 mb-3 col-md-12">
          <button
            type="button"
            class="w-100 btn btn-primary"
            (click)="onSubmit()"
            name="Submit"
            [disabled]="!valid"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
    
    <div [hidden]="!hasPermissionToStopEmails" class="row">
      <div class="col-md-12">
        <div class="mb-3 col-md-12">
          <p class="mb-3 mt-3 section-header">Email Transmission</p>
        </div>
    
        <div class="input-group mb-3 col-md-12">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <input
                type="checkbox"
                name="sendEmails"
                id="ChkBoxSendEmails"
                [checked]="!this.emailStopValue"
                (change)="toggleCheckbox()"
              />
            </div>
          </div>
          <Label class="form-control" for="ChkBoxSendEmails">
            Send Emails
          </Label>
        </div>
        <div class="mt-3 mb-3 col-md-12">
          <button
            type="button"
            class="w-100 btn btn-primary"
            (click)="onEmailToggleSubmit()"
            [disabled]="this.originalEmailStopValue == this.emailStopValue"
            name="Submit"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-12">
        <div class="mb-2 col-md-12">
          <p class="mb-0 mt-3 section-header">Send Minimums True-Up Usage</p>
        </div>
    
        <div class="mb-3 col-md-12" *ngIf="!canSendTrueUpUsage">
          <p class="mb-0 warning">Unable to send true-up usage at this time.</p>
          <p class="mb-3">The following Bill Cycles are not in Simulated Status:</p>
          <ul class="mb-3">
            <li *ngFor="let billCycle of billCyclesNotInSimulateStatusList">{{billCycle}}</li>
          </ul>
        </div>
    
        <div class="mb-3 col-md-12" *ngIf="minimumsTrueUpResponse">
          <p class="mb-3 success" *ngIf="minimumsTrueUpResponse.successful">Posting minimums true-up was successful.</p>
          <p class="mb-0 warning" *ngIf="!minimumsTrueUpResponse.successful">Posting minimums true-up was unsuccessful.</p>
          <div class="mb-3" *ngIf="!minimumsTrueUpResponse.successful">
            {{minimumsTrueUpResponse.failureMessage}}<br/>
            <ng-container *ngFor="let clientResult of minimumsTrueUpResponse.clientResults">
              <div *ngIf="!clientResult.successful" style="border-top: 1px solid black; font-size: 0.8em;">
                Salesforce ID: {{clientResult.salesforceID}}<br/>
                Avi ID: {{clientResult.aviID}}<br/>
                Failure Message: {{clientResult.failureMessage}}<br/>
                {{clientResult.erredEvents.length > 0 ? "Erred Events" : ""}}<br/>
                <div *ngFor="let erredEvent of clientResult.erredEvents" style="border-top: 1px dotted black; margin-left: 30px;">
                  Code: {{erredEvent.code}}<br/>
                  Message: {{erredEvent.message}}<br/>
                  <span *ngIf="erredEvent.unrated_usage_event !== null">
                    Description: {{erredEvent.unrated_usage_event.description}}<br/>
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
    
        <div class="col-md-3">
          <button
            type="button"
            class="w-100 btn btn-primary"
            (click)="sendTrueUpUsage()"
            name="TrueUpSubmit"
            [disabled]="!canSendTrueUpUsage || processingTrueUps || processingTrueUpsDone"
          >
            <span *ngIf="!processingTrueUps && !processingTrueUpsDone">Send True-Up Usage</span>
            <span *ngIf="processingTrueUps">Sending...</span>
            <span *ngIf="processingTrueUpsDone && minimumsTrueUpResponse.successful">True-Up Usage Sent</span>
            <span *ngIf="processingTrueUpsDone && !minimumsTrueUpResponse.successful">Error in Processing</span>
          </button>
        </div>
      </div>
    </div>

  </div>
  <div class="col-md-5 offset-sm-1">
    <h4>Sync Client to GTV</h4>

    <div class="form-group row">
      <label class="col-4 col-form-label">AVI Client Number</label>
      <div class="col-8">
        <input type="text" (keypress)="numberOnly($event)" [(ngModel)]="aviAccountNumber" maxlength="10"/>
      </div>
    </div>
    <button type="button" class="btn btn-primary" [disabled]="aviAccountNumber=='' || sendingToSalesforceSync" (click)="syncToGtv(aviAccountNumber)">Sync to GTV</button>

    <div class="mt-3"  [ngClass]="{'warning': salesforceSyncError}" *ngIf="salesforceSyncMessage" >{{salesforceSyncMessage}}</div>
    <hr /> 
    <h4>Clear Minimums from GTV</h4>
    <div class="form-group row">
      <label class="col-4 col-form-label">AVI Client Number</label>
      <div class="col-8">
        <input
        type="text"
        (keypress)="numberOnly($event)"
        [(ngModel)]="aviBillingMinClientId"
        maxlength="10"
      />
      </div>
    </div>
    <button
    type="button"
    class="btn btn-primary"
    [disabled]="aviBillingMinClientId == '' || clearingBillingMin"
    (click)="clearBillingMin(aviBillingMinClientId)"
  >
      Clear Billing Minimums
    </button>
  
    <div
      class="mt-3"
      [ngClass]="{'warning': billingMinError}"
      *ngIf="billingMinMessage"
    >
      {{ billingMinMessage }}
    </div>
  </div>
</div>

<error-handler></error-handler>
